/**
 * Contract of `GET ave-trip /trip/auto-create-trip-delivery-v2/preview`
 * (ave-trip openspec change `fs-290-trip-creation-preview`). Values mirror the
 * backend enums one to one; keep them in sync.
 */

/** Why a trip would not be created. */
export enum TripCreationPreviewReason {
  // Block the whole sub-route
  SUB_ROUTE_INACTIVE = 'SUB_ROUTE_INACTIVE',
  MODEL_NOT_APPLICABLE = 'MODEL_NOT_APPLICABLE',
  MISSING_MAIN_COLLABORATOR = 'MISSING_MAIN_COLLABORATOR',
  MISSING_RESPONSIBLE = 'MISSING_RESPONSIBLE',
  MISSING_SALES_OFFICE = 'MISSING_SALES_OFFICE',
  MISSING_ROUTE_GROUP = 'MISSING_ROUTE_GROUP',
  VEHICLE_OUT_OF_SERVICE = 'VEHICLE_OUT_OF_SERVICE',
  NO_ITINERARY = 'NO_ITINERARY',
  // Explain a single day
  NO_ACTIVE_ITINERARY = 'NO_ACTIVE_ITINERARY',
  NO_CHARGE_ACTION = 'NO_CHARGE_ACTION',
  INCOMPLETE_SEQUENCE = 'INCOMPLETE_SEQUENCE',
  TRIP_ALREADY_EXISTS = 'TRIP_ALREADY_EXISTS',
  OVERLAPS_OTHER_DAY = 'OVERLAPS_OTHER_DAY',
}

/** Itinerary level the job applied to a day. */
export enum TripCreationItinerarySource {
  SUB_ROUTE_ALTERNATIVE = 'SUB_ROUTE_ALTERNATIVE',
  SUB_ROUTE = 'SUB_ROUTE',
  ROUTE_GROUP_ALTERNATIVE = 'ROUTE_GROUP_ALTERNATIVE',
  ROUTE_GROUP = 'ROUTE_GROUP',
}

export enum TripCreationDayStatus {
  WILL_CREATE = 'WILL_CREATE',
  SKIP = 'SKIP',
}

export interface TripCreationPreviewDay {
  /** YYYY-MM-DD (UTC, as the job evaluates it). */
  date: string;
  /** Monday = 1 … Sunday = 7. */
  dayOfWeek: number;
  status: TripCreationDayStatus;
  reason?: TripCreationPreviewReason;
  itinerarySource?: TripCreationItinerarySource;
  itineraryId?: string;
  loadDate?: string;
  startDate?: string;
  endDate?: string;
  conflictingTripIds?: number[];
}

export interface TripCreationPreviewResult {
  subRouteId: string;
  window: { from: string; to: string };
  willCreate: number;
  /** Present when the sub-route is not eligible; `days` is then empty. */
  blockingReason?: TripCreationPreviewReason;
  days: TripCreationPreviewDay[];
}
